//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "AnswerSheet",
  props: {
    total: {
      type: Number,
      default: 0
    },
    index: {
      type: Number,
      default: 0
    },
    scantron: {
      type: Object,
      default: function _default() {
        return {
          list: []
        };
      }
    },
    hasSection: {
      type: Boolean,
      default: false
    },
    hasNotSupport: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      hasScroll: false
    };
  },
  watch: {
    scantron: function scantron() {
      this.initNums();
    }
  },
  methods: {
    goTo: function goTo(index) {
      this.$emit("goTo", index);
    },
    initNums: function initNums() {
      var _this = this;

      this.$nextTick(function () {
        if (_this.$refs.nums.clientHeight > document.documentElement.clientHeight - 444) {
          _this.hasScroll = true;
        } else {
          _this.hasScroll = false;
        }
      });
    }
  },
  mounted: function mounted() {
    this.initNums();
  }
};